import { Box, Grid, Typography, styled } from "@mui/material";

import { SelectBox } from "@/components";

export const UploadContainerMain = styled(Grid)(() => ({
  border: "1px solid #e4e7ec",
  marginTop: "unset !important",
  width: "100% !important",
  padding: "18px",
  alignItems: "flex-start !important",
  margin: "auto",
  marginBottom: "20px",
}));

export const UploadDetails = styled("div")(() => ({
  display: "flex",
  gap: "10px",
}));

export const UploadProgressContainer = styled(Box)(() => ({
  width: "100%",
  position: "relative",
  display: "flex",
  alignItems: "center",

  "& > span": {
    borderRadius: "4px",
    height: "8px",

    "& > span": {
      borderRadius: "4px",
      backgroundColor: "#052223",
    },
  },
}));

export const UploadProgressText = styled(Typography)(() => ({
  marginLeft: "20px !important",
  minWidth: "35px",
}));

export const UploadActions = styled(Grid)(() => ({
  display: "flex",
  justifyContent: "flex-end",
}));

export const UploadSize = styled(Typography)(() => ({
  color: "rgba(0, 0, 0, 0.54)",
}));

export const ProgressMain = styled(Box)(() => ({
  width: "100%",
  display: "flex",
  justifyContent: "end",
}));

export const ChipStyle = styled(Typography)(() => ({
  color: "#8e8f96",
  backgroundColor: "#8e8f9633",
  borderRadius: "6px",
  padding: "4px 10px",
}));

export const StyledSelectBox = styled(SelectBox)(() => ({
  "& .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded": {
    marginTop: "10px",
    backroundColor: "red",
  },
}));

export const StyledSelectBoxContainer = styled(Box)(() => ({
  marginTop: "20px",
  marginBottom: "20px",
}));
